import { render, staticRenderFns } from "./detailCollapse.vue?vue&type=template&id=3c16a40a&scoped=true&"
import script from "./detailCollapse.vue?vue&type=script&lang=js&"
export * from "./detailCollapse.vue?vue&type=script&lang=js&"
import style0 from "./detailCollapse.vue?vue&type=style&index=0&id=3c16a40a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c16a40a",
  null
  
)

export default component.exports